import { useState } from 'react';
import cx from 'classnames';

// @ts-expect-error - no TypeScript definitions yet
import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { type SavedDocumentAuthor } from 'src/data/savedDocument';
import { type CallbackN, type VoidFunction } from 'src/lib/types';

import { CommentAuthor } from './CommentAuthor';
import styles from './CommentComposer.module.scss';
import { CommentInput } from './CommentInput';

interface CommentComposerProps {
  className?: string;
  author: Pick<SavedDocumentAuthor, 'name'>;
  pending: boolean;
  onSubmit: CallbackN<[string]>;
  onHasTextChange: CallbackN<[boolean]>;
  onCancel: VoidFunction;
}

export const CommentComposer = ({
  className,
  author,
  pending,
  onSubmit,
  onHasTextChange,
  onCancel,
}: CommentComposerProps) => {
  const [text, setText] = useState('');
  const canSubmit = text.trim().length > 0;

  const handleChange = (value: string) => {
    setText(value);
    onHasTextChange(value.trim().length > 0);
  };

  const handleSubmit = () => {
    if (canSubmit && !pending) {
      onSubmit(text.trim());
    }
  };

  return (
    <div className={cx(styles.root, className)}>
      <CommentAuthor user={author} />

      <CommentInput
        value={text}
        placeholder="Comment"
        onChange={handleChange}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        autoFocus
        dataTestId="savedDocumentCommentInput"
      />

      <div className={styles.actions}>
        <CustomButton
          variant={CUSTOM_BUTTON_VARIANT.text}
          onClick={onCancel}
        >
          Cancel
        </CustomButton>
        <CustomButton
          loading={pending}
          disabled={!canSubmit || pending}
          onClick={handleSubmit}
        >
          Comment
        </CustomButton>
      </div>
    </div>
  );
};
